<template>
  <div class="details-wrapper">
    <h3
      v-if="loggedIn"
      class="greeting"
    >
      Welcome, <span class="username">{{ userName }}</span>!
    </h3>
    <h1>{{ detailsTitle }}</h1>
    <p v-if="state !== 'Setup'">
      This event runs from {{ begins }} to {{ ends }}.
      We are currently in <strong>{{ state }}</strong>.
      <span v-if="state === 'Registration'">
        The max team size is {{ maxTeamSize }}.
      </span>
      Your event {{ adminText }} {{ adminList }}.
    </p>
    <div
      v-if="notes?.length"
    >
      <vue-markdown>
        {{ notes }}
      </vue-markdown>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
  name: 'Details',
  components: {
    VueMarkdown,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detailsTitle: 'Details',
      hackathonName: this.$store.state.hackathonName,
      notes: this.$store.state.eventNotes,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    userName() {
      return this.currentUser.name;
    },
    state() {
      return this.$store.state.eventState;
    },
    begins() {
      return new Date(this.$store.state.begins).toDateString();
    },
    ends() {
      return new Date(this.$store.state.ends).toDateString();
    },
    maxTeamSize() {
      return this.$store.state.maxUsers;
    },
    admins() {
      return this.$store.state.admins;
    },
    adminList() {
      return this.admins.map((a) => a.name).join(', ');
    },
    adminText() {
      return this.admins.length > 1 ? 'admins are' : 'admin is';
    },
  },
};
</script>

<style lang="scss" scoped>
.greeting {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 20px;
  padding-bottom: 1em;
}

.greeting > .username {
  color: #f26522;
}

::v-deep a {
  color: #004e7d;
  font-weight: bolder;
  text-decoration: none;
}

::v-deep a:hover {
  color: #004e7d;
  font-weight: bolder;
  text-decoration: underline;
}
</style>
